import { render, staticRenderFns } from "./sendTeam.vue?vue&type=template&id=38b0f863&scoped=true&"
import script from "./sendTeam.vue?vue&type=script&lang=js&"
export * from "./sendTeam.vue?vue&type=script&lang=js&"
import style0 from "./sendTeam.vue?vue&type=style&index=0&id=38b0f863&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0f863",
  null
  
)

export default component.exports